import SectionHero from "components/SectionHero/SectionHero";
import image from "images/promo3.png";

export default () => {
  return (
    <main className="container py-10">
      <SectionHero
        title="¡Solicitud de Devolución Recibida!"
        subtitle="En Breve recibirá un email con la información de su Devolución."
        img={image}
        bg={'#edf7ea'}
      />
    </main>
  );
};
